/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { MED_DATETIME_NO_YEAR_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/grading';

type Props = {
  dueDateTs: number;
};

const styles = {
  dueTitle: css`
    margin-right: var(--cds-spacing-100);
  `,
};

// Component for SGA top bar due date display
const DueDate = ({ dueDateTs }: Props) => {
  return (
    <div>
      <Typography2 variant="bodyPrimary" component="span" css={styles.dueTitle}>
        {_t('Due:')}
      </Typography2>
      <Typography2 variant="bodyPrimary" component="span">
        {formatDateTimeDisplay(dueDateTs, MED_DATETIME_NO_YEAR_DISPLAY)}
      </Typography2>
    </div>
  );
};

export default DueDate;
